import React from 'react';
import { generateAreaServedSchema } from '@/components/ui/sections/ServiceAreas/consts';

const DOMAIN = 'https://www.cornerstonehomesok.com';

function ServiceAreasStructuredData() {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: DOMAIN,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'About',
        item: `${DOMAIN}/about`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Service Areas',
        item: `${DOMAIN}/about/our-service-areas`,
      },
    ],
  };

  const businessSchema = {
    '@context': 'https://schema.org',
    '@type': 'HomeAndConstructionBusiness',
    '@id': `${DOMAIN}/#organization`,
    name: 'Cornerstone Homes & Properties, LLC.',
    url: DOMAIN,
    telephone: '+1-918-344-1731',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '16380 E 430 Rd',
      addressLocality: 'Claremore',
      addressRegion: 'OK',
      postalCode: '74017',
      addressCountry: 'US',
    },
    areaServed: generateAreaServedSchema(),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(businessSchema) }}
      />
    </>
  );
}

export default ServiceAreasStructuredData;
